module.exports = __webpack_public_path__ + "img/d-p-01.51314b7c.png";